import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import { type LWApiPublicNetworkLoadBalancerStrategiesResultI } from '@liquidweb-dev/club-sauce/public/network/loadbalancer/index.raw';
import type { ApiErrorI } from '@liquidweb-dev/club-sauce/types/apiError';
import api from 'modules/queries/api';

export const NETWORK_LOADBALANCER_STRATEGIES_QUERY_KEY =
	'/network/loadbalancer/strategies';

const useLoadBalancerStrategies = <
	TData = LWApiPublicNetworkLoadBalancerStrategiesResultI,
>(
	options?: UseQueryOptions<
		LWApiPublicNetworkLoadBalancerStrategiesResultI,
		ApiErrorI,
		TData
	>,
) =>
	useQuery({
		queryKey: [NETWORK_LOADBALANCER_STRATEGIES_QUERY_KEY],
		queryFn: () => api.network.loadbalancer.apiRaw.strategies(),
		...options,
	});

export default useLoadBalancerStrategies;
